import React from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import CheckoutForm from './CheckoutForm'
import CartCheckoutForm from './CartCheckoutForm'
import '../Styles/PaymentPanel.scss'

const stripePromise = loadStripe('pk_live_51Qj8NvRstlwNU15E4RDarYStMSEcfHxbadUFqI9kSoC2Ux263Q9MNwMSVwFVhPLMxYWzD6R5MZDH2Eet5lG6afAY00VDLdBkCa')

// Stripe Elements plus a breakdown of what the charge covers.
//
// Two modes, because the cart and the dashboard confirm payments differently:
//
//   pay given           deferred intent. No PaymentIntent exists yet; the form produces a
//                       ConfirmationToken and the server creates, checks and confirms in one
//                       request. This is the cart's path.
//   clientSecret given  an intent already exists and the browser confirms it. The balance-payment
//                       path, unchanged.
//
// Deliberately dumb either way: it renders the lines it is handed and never calculates a total.
function PaymentPanel({ clientSecret, lines = [], totalCents, onPaid, pay, onSettled, onProcessingChange, busyLabel }) {

   const deferred = !clientSecret

   // Deferred mode needs an amount to render the Element; the confirming path needs its secret.
   if (deferred ? !(totalCents > 0) || !pay : !clientSecret) {
      return null
   }

   const options = deferred
      ? { mode: 'payment', amount: totalCents, currency: 'usd', paymentMethodTypes: ['card'] }
      : { clientSecret }

   const asDollars = (cents) => (cents / 100).toFixed(2)

   return (
      <div className="PaymentPanelContainer">
         <div className="PaymentPanelBreakdown">
            {lines.map(line => (
               <div className="PaymentPanelLine" key={line.key}>
                  <div className="PaymentPanelLineLabel">{line.label}</div>
                  <div className="PaymentPanelLineAmount">${asDollars(line.amountCents)}</div>
               </div>
            ))}
            <div className="PaymentPanelTotal">
               <div>Total charged today</div>
               <div>${asDollars(totalCents)}</div>
            </div>
         </div>

         <Elements stripe={stripePromise} options={options}>
            {deferred
               ? <CartCheckoutForm
                    pay={pay}
                    onSettled={onSettled}
                    onProcessingChange={onProcessingChange} />
               : <CheckoutForm
                    setPaymentIntent={onPaid}
                    onProcessingChange={onProcessingChange} />}
         </Elements>

         {busyLabel && <div className="PaymentPanelBusy">{busyLabel}</div>}
      </div>
   )
}

export default PaymentPanel
